module.exports = __webpack_public_path__ + "static/media/wall-violet.9e0af120.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/wall-violet.png
// module id = 145
// module chunks = 0